import React from 'react'
import InfoSection from 'components/InfoSection'
import RamblerCoIcon from 'components/icons/RamblerCoIcon'

export default function SideInfoPromo() {
  return (
    <InfoSection
      icon={<RamblerCoIcon />}
      title={
        <a
          href="https://id.rambler.ru/info/"
          target="_blank"
          rel="noopener noreferrer">
          Единый профиль RAMBLER&amp;Co&nbsp;ID
        </a>
      }>
      Узнайте, как ваш Единый профиль открывает полный доступ к самым популярным
      сайтам российского интернета
    </InfoSection>
  )
}
